import { render, staticRenderFns } from "./logiststList.vue?vue&type=template&id=315a96a6&scoped=true"
import script from "./logiststList.vue?vue&type=script&lang=js"
export * from "./logiststList.vue?vue&type=script&lang=js"
import style0 from "./logiststList.vue?vue&type=style&index=0&id=315a96a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315a96a6",
  null
  
)

export default component.exports